<template lang="pug">
  sw-drawer(
    :show="show"
    data-purpose-prop="open_operator_drawer_button"
  )
    span(slot='expandButtonText') {{ $t('shared.theOperatorDrawer.title') }}
    div.p-4
      h4.underline.text-2xl.text-center.px-6.mb-6 {{ $t('shared.theOperatorDrawer.title') }}
      h5 {{ $t('shared.theOperatorDrawer.existingSimulation') }}
      ul.my-2(data-turbolinks="false")
        li.flex.items-center.text-xs.mt-2(v-for="contractRequest in initialData.ongoing_contract_requests")
          a.flex.items-center.font-medium.text-gray-600(
            :class="contractRequest.active ? 'text-blue-500' : ''"
            :href="contractRequest.link"
            class="hover:text-gray-400"
          )
            sw-icon(
              :name="contractRequest.icon"
              size="w-4 h-4"
            )
            span.ml-2 {{ contractRequest.displayed_risk_object_alias }}
          sw-icon.ml-2(
            v-if="contractRequest.display_check"
            name="check"
          )
          sw-button.btn.btn-blue.btn-xs.ml-2(
            v-if="contractRequest.display_add_to_full_package_bundle_button"
            @click="handleAddToFpb(contractRequest.uuid)"
          )
            sw-icon.mr-2(name="shopping-cart" size="w-4 h-4")
            span {{ $t('shared.theOperatorDrawer.addToFullPackageBundle') }}
        li.flex.items-center.text-xs.mt-2(v-if="initialData.civil_liability_in_full_package_bundle")
          span.flex.items-center.font-medium.text-gray-600(class="hover:text-gray-400")
            sw-icon(name="family-child" size="w-4 h-4")
            span.ml-2 {{ $t('shared.theOperatorDrawer.familyCivilLiability') }}
          sw-icon.ml-2(name="check")
        the-civil-liability-form.mt-2(v-else :insurers="initialData.insurer_options" :coverages="initialData.coverage_options")
      hr
      sw-markdown-textarea(
        v-model="operatorComment"
        :placeholder="$t('shared.theOperatorDrawer.operatorsNote')"
        custom-classes="border-gray-300 border-2 rounded text-gray-700 font-medium w-64 mt-4 mb-2 px-3 py-3 text-xs hover:border-green-900 focus:outline-none focus:border-green-900"
        @blur="handleSubmit"
        @focus="handleFocus"
      )
      span.flex.items-center.mb-4(v-if="!typing" :class="success ? 'text-green-900' : 'text-red-500'")
        sw-icon(
          :name="success ? 'check-circle' : 'close'"
          size="w-4 h-4"
        )
        .text-xs.ml-1 {{ message }}
      sw-popover(
        custom-classes="z-50 w-64 bg-white rounded m-3 p-2 relative border text-gray-300 border-gray-300 shadow-md"
        placement="bottom"
        trigger="hover"
      )
        span.flex.items-center.mb-4
          sw-icon(
            name="info"
            size="w-4 h-4"
          )
          .text-xs.ml-1 {{ $t('shared.theOperatorDrawer.popover.title') }}
        div(slot="popover-content")
          .text-gray-600.text-xs(v-html="$t('shared.theOperatorDrawer.popover.guidance')")
      hr
      h5.my-2 {{ $t('shared.theOperatorDrawer.newSimulation') }}
      ul.my-2(data-turbolinks="false")
        li( v-for="link in initialData.new_purchase_links")
          a.font-medium.text-gray-600.flex.items-center.text-xs.mt-2(
            :href="link.link"
            class="hover:text-gray-400"
          )
            sw-icon(
              :name="link.product"
              size="w-4 h-4"
            )
            span.ml-2 {{ $t(`shared.productItems.${link.product}`) }}
</template>

<script>
import axios from 'axios';
import SwDrawer from '../generic/SwDrawer';
import SwMarkdownTextarea from '../ui-elements/SwMarkdownTextarea';
import TheCivilLiabilityForm from '../ui-elements/TheCivilLiabilityForm';

export default {
  name: 'TheOperatorDrawer',
  components: {
    SwDrawer,
    SwMarkdownTextarea,
    TheCivilLiabilityForm,
  },
  props: {
    initialRawData: {
      type: String,
      default: null,
    },
  },
  data: function () {
    return {
      show: false,
      operatorComment: '',
      typing: true,
      message: '',
      success: null,
    };
  },
  computed: {
    initialData () {
      return JSON.parse(this.initialRawData);
    },
  },
  created () {
    this.operatorComment = this.initialData.operator_comment || localStorage.operatorComment;
    if (this.operatorComment) this.show = true;
  },
  methods: {
    handleAddToFpb (uuid) {
      axios.post(`/back_office/contract_requests/${uuid}/add_to_full_package_bundle`)
        .then (data => {
          window.location.href = data.request.responseURL;
          // TODO Handle flash success and errors messages
        });
    },
    handleSubmit () {
      axios.put('/back_office/user', { operator_comment: this.operatorComment })
      .then(({ data }) => {
        this.typing = false;
        const { message, success } = data;
        this.message = message;
        this.success = success;
      })
      .catch(() => {
        this.message = this.$t('shared.theOperatorDrawer.messages.errors.operatorCommentNotSaved');
        this.success = false;
        this.typing = false;
      });
    },
    handleFocus () {
      this.typing = true;
    },
    resetForm () {
      switch (window.location.pathname){
        case `/${this.$i18n.locale}/products/cars/profiling`:
          localStorage.removeItem('cars_profiling');
          window.location.href = `/${this.$i18n.locale}/products/cars/profiling`;
          break;
        case `/${this.$i18n.locale}/products/life/profiling`:
          localStorage.removeItem('life_profiling');
          window.location.href = `/${this.$i18n.locale}/products/life/profiling`;
          break;
        case `/${this.$i18n.locale}/products/motorbikes/profiling`:
          localStorage.removeItem('motorbikes_profiling');
          window.location.href = `/${this.$i18n.locale}/products/motorbikes/profiling`;
          break;
        case `/${this.$i18n.locale}/products/houses/profiling`:
          localStorage.removeItem('houses_profiling');
          window.location.href = `/${this.$i18n.locale}/products/houses/profiling`;
          break;
      }
    },
  },
};
</script>
